var $export   = require('./_export')
  , $parseInt = require('./_parse-int');
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es6.number.parse-int.js
// module id = 964
// module chunks = 10